import { LruObjectCache, createCachedSelector } from 're-reselect';

import { accountsSelectors } from 'app-components/flux/accounts';
import { institutionLoginsSelectors } from 'app-components/flux/institution-logins';

export const hasConnectedAccounts = createCachedSelector(
  (state, props) => institutionLoginsSelectors.getInstitutionLoginForId(state, props.institutionLoginId),
  accountsSelectors.getAccountsForInstitutionLoginId,
  (institutionLogin, accounts) => {
    if (!institutionLogin) {
      return false;
    }
    if (institutionLogin.aggregators?.get(0).cpId) {
      return true;
    }
    const found = accounts.find((account) => account.aggregators?.get(0).cpId);
    return !!found;
  },
)({
  keySelector: (state, props) => props.institutionLoginId || '0',
  cacheObject: new LruObjectCache({ cacheSize: 25 }),
});
